import { exists } from '@/api'

export interface AuthorityAuthor {
  display: string
  displayKana: string
  specialty: string
  yearOfBirth: string
  work: string
  tag: string
  authorityNo: string
}

export function AuthorityAuthorFromJSON(json: any): AuthorityAuthor {
  return {
    display: exists(json, 'display') ? json.display : '',
    displayKana: exists(json, 'display_kana') ? json.display_kana : '',
    specialty: exists(json, 'specialty') ? json.specialty : '',
    yearOfBirth: exists(json, 'year_of_birth') ? json.year_of_birth : '',
    work: exists(json, 'work') ? json.work : '',
    tag: exists(json, 'tag') ? json.tag : '',
    authorityNo: exists(json, 'authority_no') ? String(json.authority_no) : ''
  }
}
